document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".tab-btn");
  const noteDescription = document.getElementById("note-description");
  const noteImage = document.getElementById("note-image");

  buttons.forEach((button) => {
    button.addEventListener("click", (e) => {
      // Remove 'active' class from all buttons
      buttons.forEach((btn) => btn.classList.remove("active"));

      // Add 'active' class to the clicked button
      e.target.classList.add("active");

      // Update the content and image
      const note = e.target.dataset.note;
      const desc = e.target.dataset.desc;
      const image = e.target.dataset.image;

      noteDescription.innerHTML = `<h3>${note}</h3><p>${desc}</p>`;
      noteImage.src = image;
      noteImage.alt = note;
    });
  });
});
